// ** UI
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';

// ** Components
import { Icon } from '@/components/common/icons';

const arrowSx = {
	color: 'common.white',
	p: 0,
	transition: 'opacity 0.2s ease, transform 0.14s ease',
	'&:hover': {
		opacity: 1,
		transform: 'translateY(-1px)',
		bgcolor: 'transparent'
	},
	'&:active': { transform: 'translateY(0) scale(0.98)' },
	'&:disabled': { color: '#FFFFFF7A', opacity: 1 },
	'&:focusVisible': {
		outline: '2px solid',
		outlineColor: 'common.white',
		outlineOffset: 4
	}
};

const LightboxPrevArrow = ({
	hasPrev,
	onPrev,
	show,
	label = 'Zurück'
}: {
	hasPrev: boolean;
	onPrev: () => void;
	show: boolean;
	label?: string;
}) => (
	<Box
		sx={{
			flexShrink: 0,
			width: 80,
			display: { xs: 'none', md: 'flex' },
			justifyContent: 'center'
		}}
	>
		{show && (
			<IconButton onClick={onPrev} disabled={!hasPrev} disableRipple aria-label={label} sx={arrowSx}>
				<Icon name="arrowLeft" width={32} height={16} color="white" opacity={hasPrev ? 1 : 0.3} />
			</IconButton>
		)}
	</Box>
);

const LightboxNextArrow = ({
	hasNext,
	onNext,
	show,
	label = 'Weiter'
}: {
	hasNext: boolean;
	onNext: () => void;
	show: boolean;
	label?: string;
}) => (
	<Box
		sx={{
			flexShrink: 0,
			width: 80,
			display: { xs: 'none', md: 'flex' },
			justifyContent: 'center'
		}}
	>
		{show && (
			<IconButton onClick={onNext} disabled={!hasNext} disableRipple aria-label={label} sx={arrowSx}>
				<Icon name="arrowRight" width={32} height={16} color="white" opacity={hasNext ? 1 : 0.3} />
			</IconButton>
		)}
	</Box>
);

export { LightboxPrevArrow, LightboxNextArrow, arrowSx };
